<template>
  <view-box
    v-if="$store.state.displayDetailView && $store.state.poi !== undefined"
    class="view-box viewboxvisible"
    :heading="$t('detailView.heading')"
    icon="mdi-format-list-bulleted"
  >
    <div
      class="container pa-1 pt-3 inviewbox"
      :style="$mq | mq({
        desktop:'width: 100%;'
      })"
    >
      <div class="content">
        <v-list-item>
          <v-list-item-avatar
            tile
          >
            <v-icon color="#0D0D0D">
              {{ $icons.getIconById($store.state.poi.category).icon }} mdi-36px
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline text-wrap">
              {{ $store.state.poi.label }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              {{ $store.state.poi.sublabel }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-simple-table
          fixed-header
          width="100%"
        >
          <template v-slot:default>
            <tbody>
              <tr v-if="$mq === 'mobile'">
                <td>Zur Karte</td>
                <td>
                  <v-btn
                    class="ma-1"
                    :color="baseColor"
                    @click="$store.commit('hideSubMenus');$store.commit('closeSearchMenu');$store.commit('closeDetailView');"
                  >
                    <v-icon>
                      mdi-map-outline
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr>
                <td>{{ $t('various.category') }}</td>
                <td class="text-capitalize">
                  {{ $store.state.poi.category }}
                </td>
              </tr>
              <tr
                v-for="(cat, i) in searchableCategories"
                v-show="$store.state.poi.category === 'adressen'"
                :key="i+100"
              >
                <td>Nach {{ cat.id }} suchen</td>
                <td>
                  <v-btn
                    class="ma-1"
                    :color="baseColor"
                    @click="handleSolrRequest(cat.id)"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr
                v-for="(value, name, i) in $store.state.poi.meta"
                :key="i"
              >
                <td
                  v-if="value !== null"
                >
                  {{ name }}
                </td>
                <td
                  v-if="value !== null && value.startsWith('http')"
                >
                  <v-btn
                    :href="value"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null && (value === 'true' || value === 'false')"
                >
                  <v-icon
                    v-if="isTrue(value)"
                    color="green"
                  >
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="red"
                  >
                    mdi-close
                  </v-icon>
                </td>
                <td
                  v-else-if="name === 'Wikipedia'"
                >
                  <v-btn
                    :href="linkToWikipedia(value)"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null && value.startsWith('/')"
                >
                  <v-btn
                    :href="linkToDataDirectory(value)"
                    class="ma-1"
                    target="_blank"
                    link
                    :color="baseColor"
                  >
                    <v-icon>
                      mdi-earth
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  v-else-if="value !== null"
                >
                  {{ value }}
                </td>
              </tr>
              <h4
                v-if="getCatContact() !== undefined"
                style="margin:24px 0 0 16px"
              >
                {{ $t('various.moreInformation') }}
              </h4>
              <tr v-if="categoryContact !== undefined && categoryContact.name !== undefined">
                <td> {{ $t('various.name') }}</td>
                <td>{{ categoryContact.name }}</td>
              </tr>
              <tr v-if="categoryContact !== undefined && categoryContact.department !== undefined">
                <td> {{ $t('various.department') }}</td>
                <td>{{ categoryContact.department }}</td>
              </tr>
              <tr v-if="categoryContact !== undefined && categoryContact.phone !== undefined">
                <td> {{ $t('various.phone') }}</td>
                <td>{{ categoryContact.phone }}</td>
              </tr>
              <tr v-if="categoryContact !== undefined && categoryContact.email !== undefined">
                <td> {{ $t('various.email') }}</td>
                <td>{{ categoryContact.email }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </view-box>
</template>

<script>

import ViewBox from '../ViewBox.vue';
import { EventBus } from '../../event-bus';

const displayed = false;

export default {
  name: 'DetailView',
  components: {
    ViewBox,
  },
  props: {
  },
  data() {
    return {
      search: '',
      select: '',
      displayed,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      mapCenter: this.$appConfig.mapCenter,
      searchGeom: undefined,
      getMdiIconById: 'mdi-home',
      categories: this.$appConfig.categories,
      categoryContact: undefined,
    };
  },
  computed: {
    searchableCategories() {
      return this.categories.filter((cat) => cat.searchable === true);
    },
  },
  methods: {
    handleSolrRequest(catToSearchFor) {
      if (this.$mq === 'mobile') {
        this.$store.commit('showSearchMenu');
      }
      EventBus.$emit('searchAtPoi', catToSearchFor, this.$store.state.poi);
    },
    capitalizeFLetter(s) {
      return `${s[0].toUpperCase()}${s.slice(1).toLowerCase()}`;
    },
    linkToDataDirectory(uri) {
      return `${this.$appConfig.dataDirectoryPath}${uri}`;
    },
    linkToWikipedia(wiki) {
      const lang = (wiki.split(':'))[0];
      const uri = (wiki.split(':'))[1];
      return `http://${lang}.wikipedia.org/wiki/${uri}`;
    },
    isTrue(string) {
      if (string === 'true') return true;
      return false;
    },
    getCatContact() {
      const x = this.categories.find((e) => e.id === this.$store.state.poi.category);
      if (x.contact !== undefined) {
        this.categoryContact = x.contact;
      } else {
        this.categoryContact = undefined;
      }
      return this.categoryContact;
    },
  },
};

</script>

<style scoped>

  .container {
    background-color: transparent;
    visibility: visible;
    /* width: inherit; */
    height: auto;
  }
  .content {
    /* max-height: 95vh; */
    overflow-y: auto;
    width: 100%;
    padding-bottom: 80px;
  }
  @media (min-width: 1250px) {
    .viewboxvisible {
      visibility: visible;
    }
    .inviewbox {
      top: auto !important;
    }
  }
</style>
